if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			// Prevent form submission to avoid page reload
			// Remove existing listener first to avoid duplicates
			if (this.form && !this.form.dataset.ajaxified) {
				this.form.addEventListener('submit', (e) => {
					// Allow checkout submission but prevent quantity updates submission
					if (!e.submitter || e.submitter.name !== 'checkout') {
						e.preventDefault();
					}
				});
				this.form.dataset.ajaxified = 'true';
			}

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				// Skip if already ajaxified to prevent duplicate listeners
				if (item.dataset.ajaxified) {
					return;
				}
				item.dataset.ajaxified = 'true';

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;

					// Re-initialize AJAX functionality after updating cart HTML
					if (cartItems && typeof cartItems.ajaxifyCartItems === 'function') {
						cartItems.ajaxifyCartItems();
					}

					// Update shipping notice in cart drawer (outside AjaxCartForm)
					const newShippingNoticeWrapper = sectionInnerHTML.getElementById('CartDrawerShippingNotice');
					const existingShippingNoticeWrapper = document.getElementById('CartDrawerShippingNotice');
					if (newShippingNoticeWrapper && existingShippingNoticeWrapper) {
						existingShippingNoticeWrapper.innerHTML = newShippingNoticeWrapper.innerHTML;
						// Re-initialize the shipping-notice custom element
						const shippingNotice = existingShippingNoticeWrapper.querySelector('shipping-notice');
						if (shippingNotice && typeof shippingNotice.init === 'function') {
							shippingNotice.init();
						}
					} else if (newShippingNoticeWrapper && !existingShippingNoticeWrapper) {
						// Cart now has items, add shipping notice before AjaxCartForm
						const wrapper = document.createElement('div');
						wrapper.id = 'CartDrawerShippingNotice';
						wrapper.className = 'cart-drawer-shipping-notice-wrapper';
						wrapper.innerHTML = newShippingNoticeWrapper.innerHTML;
						cartItems.parentNode.insertBefore(wrapper, cartItems);
					} else if (!newShippingNoticeWrapper && existingShippingNoticeWrapper) {
						// Cart is now empty, remove shipping notice
						existingShippingNoticeWrapper.remove();
					}

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					}

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

					// Dispatch cart-updated event on document for global listeners
					const event = new Event('cart-updated', { bubbles: true });
					document.dispatchEvent(event);

					// Also dispatch on the form element for backward compatibility
					this.dispatchEvent(new Event('cart-updated'));

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	}


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();

			// Use event delegation to avoid duplicate listeners
			if (!this.dataset.initialized) {
				this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
				this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
				this.dataset.initialized = 'true';
			}
		}
		changeCartInput(e){
			e.preventDefault();
			setTimeout(()=>{
				const cartForm = document.getElementById('AjaxCartForm');
				if (cartForm && typeof cartForm.updateCartQty === 'function') {
					cartForm.updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
				}
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {

		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;

			// Re-initialize AJAX functionality after updating cart HTML
			if (cartItems && typeof cartItems.ajaxifyCartItems === 'function') {
				cartItems.ajaxifyCartItems();
			}

			// Update shipping notice in cart drawer (outside AjaxCartForm)
			const newShippingNoticeWrapper = sectionInnerHTML.getElementById('CartDrawerShippingNotice');
			const existingShippingNoticeWrapper = document.getElementById('CartDrawerShippingNotice');
			if (newShippingNoticeWrapper && existingShippingNoticeWrapper) {
				existingShippingNoticeWrapper.innerHTML = newShippingNoticeWrapper.innerHTML;
				// Re-initialize the shipping-notice custom element
				const shippingNotice = existingShippingNoticeWrapper.querySelector('shipping-notice');
				if (shippingNotice && typeof shippingNotice.init === 'function') {
					shippingNotice.init();
				}
			} else if (newShippingNoticeWrapper && !existingShippingNoticeWrapper) {
				// Cart now has items, add shipping notice before AjaxCartForm
				const wrapper = document.createElement('div');
				wrapper.id = 'CartDrawerShippingNotice';
				wrapper.className = 'cart-drawer-shipping-notice-wrapper';
				wrapper.innerHTML = newShippingNoticeWrapper.innerHTML;
				cartItems.parentNode.insertBefore(wrapper, cartItems);
			} else if (!newShippingNoticeWrapper && existingShippingNoticeWrapper) {
				// Cart is now empty, remove shipping notice
				existingShippingNoticeWrapper.remove();
			}

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})

			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

			// Dispatch cart-updated event on document for global listeners
			document.dispatchEvent(new Event('cart-updated', { bubbles: true }));

			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, {
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body
						});
		  		}, 150)
				);
      }
    }
  );
}